export async function openSocialPopup(event, { openWindow, request, onStatus, onError }) {
  const popup = openWindow("about:blank", "_blank", "popup=yes,width=540,height=720,resizable=yes,scrollbars=yes")
  // Browser blocks popups: allow the ordinary POST form target=_blank fallback.
  if (!popup) return
  event.preventDefault()
  popup.opener = null
  try {
    const payload = await request()
    if (popup.closed) return
    popup.location.replace(payload.url)
    onStatus(payload.message)
  } catch (error) {
    popup.close()
    onError()
  }
}
